
export const getFeatureFilterTemplate = () => ({
    categoryIds: [],
    showCommonFeatures: 0,
});
